// @ts-ignore
const settings = {
    owner: 'owner-pl',
};

export function setSettings(term: string | number, value: any) {
    // @ts-ignore
    settings[term] = value;
}

export default function getSettings() {

    return settings;
}
